'use client';

import { useState, useEffect } from 'react';
import Icon from '@/components/ui/AppIcon';

interface Stat {
  icon: string;
  value: string;
  label: string;
  suffix: string;
}

export default function StatsSection() {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  const stats: Stat[] = [
    {
      icon: "CheckBadgeIcon",
      value: "70",
      label: "Projects Completed",
      suffix: "+"
    },
    {
      icon: "UserGroupIcon",
      value: "50",
      label: "Happy Clients",
      suffix: "+"
    },
    {
      icon: "ClockIcon",
      value: "4",
      label: "Years Experience",
      suffix: "+"
    },
    {
      icon: "ChartBarIcon",
      value: "99",
      label: "Client Retention",
      suffix: "%"
    }
  ];

  if (!isHydrated) {
    return (
      <section data-component-id="src/app/about/components/StatsSection.tsx:49:6" data-component-path="src/app/about/components/StatsSection.tsx" data-component-line="49" data-component-file="StatsSection.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22className%22%3A%22w-full%20py-16%20bg-gradient-to-br%20from-brand-primary%20to-brand-trust%22%7D" className="w-full py-16 bg-gradient-to-br from-brand-primary to-brand-trust">
        <div data-component-id="src/app/about/components/StatsSection.tsx:50:8" data-component-path="src/app/about/components/StatsSection.tsx" data-component-line="50" data-component-file="StatsSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22max-w-7xl%20mx-auto%20px-6%20lg%3Apx-8%22%7D" className="max-w-7xl mx-auto px-6 lg:px-8">
          <div data-component-id="src/app/about/components/StatsSection.tsx:51:10" data-component-path="src/app/about/components/StatsSection.tsx" data-component-line="51" data-component-file="StatsSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20md%3Agrid-cols-2%20lg%3Agrid-cols-4%20gap-8%22%7D" className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {[1, 2, 3, 4].map((i) => (
              <div data-component-id="src/app/about/components/StatsSection.tsx:53:14" data-component-path="src/app/about/components/StatsSection.tsx" data-component-line="53" data-component-file="StatsSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22animate-pulse%20bg-white%2F10%20h-32%20rounded-xl%22%7D" key={i} className="animate-pulse bg-white/10 h-32 rounded-xl"></div>
            ))}
          </div>
        </div>
      </section>
    );
  }

  return (
    <section data-component-id="src/app/about/components/StatsSection.tsx:62:4" data-component-path="src/app/about/components/StatsSection.tsx" data-component-line="62" data-component-file="StatsSection.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22className%22%3A%22w-full%20py-16%20bg-gradient-to-br%20from-brand-primary%20to-brand-trust%20text-white%22%7D" className="w-full py-16 bg-gradient-to-br from-brand-primary to-brand-trust text-white">
      <div data-component-id="src/app/about/components/StatsSection.tsx:63:6" data-component-path="src/app/about/components/StatsSection.tsx" data-component-line="63" data-component-file="StatsSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22max-w-7xl%20mx-auto%20px-6%20lg%3Apx-8%22%7D" className="max-w-7xl mx-auto px-6 lg:px-8">
        <div data-component-id="src/app/about/components/StatsSection.tsx:64:8" data-component-path="src/app/about/components/StatsSection.tsx" data-component-line="64" data-component-file="StatsSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20md%3Agrid-cols-2%20lg%3Agrid-cols-4%20gap-8%22%7D" className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((stat) => (
            <div data-component-id="src/app/about/components/StatsSection.tsx:66:12" data-component-path="src/app/about/components/StatsSection.tsx" data-component-line="66" data-component-file="StatsSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22bg-white%2F10%20backdrop-blur-sm%20p-8%20rounded-xl%20text-center%20hover%3Abg-white%2F20%20transition-all%20duration-base%20hover%3Ascale-105%22%7D"
              key={stat.label}
              className="bg-white/10 backdrop-blur-sm p-8 rounded-xl text-center hover:bg-white/20 transition-all duration-base hover:scale-105"
            >
              <div data-component-id="src/app/about/components/StatsSection.tsx:70:14" data-component-path="src/app/about/components/StatsSection.tsx" data-component-line="70" data-component-file="StatsSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-16%20h-16%20bg-white%2F20%20rounded-xl%20flex%20items-center%20justify-center%20mx-auto%20mb-4%22%7D" className="w-16 h-16 bg-white/20 rounded-xl flex items-center justify-center mx-auto mb-4">
                <Icon data-component-id="src/app/about/components/StatsSection.tsx:71:16" data-component-path="src/app/about/components/StatsSection.tsx" data-component-line="71" data-component-file="StatsSection.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22className%22%3A%22text-white%22%7D" name={stat.icon as any} size={32} className="text-white" />
              </div>
              <div data-component-id="src/app/about/components/StatsSection.tsx:73:14" data-component-path="src/app/about/components/StatsSection.tsx" data-component-line="73" data-component-file="StatsSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22text-4xl%20font-bold%20mb-2%22%7D" className="text-4xl font-bold mb-2">
                {stat.value}{stat.suffix}
              </div>
              <p data-component-id="src/app/about/components/StatsSection.tsx:76:14" data-component-path="src/app/about/components/StatsSection.tsx" data-component-line="76" data-component-file="StatsSection.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-white%2F90%20font-medium%22%7D" className="text-white/90 font-medium">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}